import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import LinkButton from '../../components/link-button';
import CreatePostHandler from '../../../app/containers/create-post-handler';
import ensureAuth from '../../../app/hoc/ensure-auth';
import withPermissions from '../../../app/hoc/with-permissions';
import withTranslate from '../../../app/hoc/with-translate';

const ButtonSecure = ensureAuth(LinkButton);

export const CreatePostButton = ({ can, t, biPage }) =>
  can('create', 'post') ? (
    <CreatePostHandler biPage={biPage}>
      <ButtonSecure data-hook="create-post">{t('create-post-button.label')}</ButtonSecure>
    </CreatePostHandler>
  ) : null;

CreatePostButton.propTypes = {
  can: PropTypes.func,
  t: PropTypes.func,
  biPage: PropTypes.string,
};

// prettier-ignore
export default flowRight(
  withPermissions,
  withTranslate
)(CreatePostButton);
